
export class EventBus extends EventTarget {
    publish(type: string, data: any = {}) {
        this.dispatchEvent(new CustomEvent(type, {detail: data}))
    }

    subscribe(event: string, listener: (event: CustomEvent) => void) {
        this.addEventListener(event, listener as EventListener)
    }

    unsubscribe(event: string, listener: (event: CustomEvent) => void) {
        this.removeEventListener(event, listener as EventListener)
    }
}

export default new EventBus()